import { useMutation } from '@tanstack/react-query'

import axiosInstance from '@/libs/configs/axios'

export type TGuestRegiserPayload = {
  partner_id: string
  signed: string
  utm_source?: string
}

export type TGuestRegiserResult = {
  success: boolean
  traceId: string
  error?: {
    code: string
    message: string
    errors: any[]
  }
  metadata: unknown
  result: {
    username: string
    accessToken: string
    refreshToken: string
    expiresAt: string
    isRegistered: boolean
  }
}

async function postGuestRegiserAPI(
  { partner_id, signed, utm_source }: TGuestRegiserPayload,
  useMockServer: boolean = false,
): Promise<TGuestRegiserResult> {
  try {
    const result = await axiosInstance({
      baseURL: useMockServer
        ? process.env.NEXT_PUBLIC_MOCK_API_URL
        : process.env.NEXT_PUBLIC_API_URL,
      url: `/auth/partner/guest`,
      method: 'post',
      data: {
        partner_id,
        signed,
        utm_source,
      },
    })

    return result?.data
  } catch (error: any) {
    throw error?.response?.data
  }
}

export default function usePostGuestRegiserMutation() {
  const { mutate, isPending, isSuccess, data, error } = useMutation({
    mutationFn: ({ partner_id, signed, utm_source }: TGuestRegiserPayload) =>
      postGuestRegiserAPI({
        partner_id,
        signed,
        utm_source,
      }),
  })

  return {
    mutate,
    data,
    isPending,
    isSuccess,
    error,
  }
}
